import { type IconName } from '@shared/icon';

export interface MenuActionItem {
  readonly kind?: 'item';
  readonly value: string;
  readonly labelKey?: string;
  readonly label?: string;
  readonly descriptionKey?: string;
  readonly description?: string;
  readonly icon?: IconName;
  readonly trailingIcon?: IconName;
  readonly trailingLabelKey?: string;
  readonly disabled?: boolean;
  readonly destructive?: boolean;
  readonly visible?: boolean;
}

export interface MenuGroupItem {
  readonly kind: 'group';
  readonly titleKey: string;
  readonly titleParams?: Record<string, string | number>;
  readonly actionLabelKey?: string;
  readonly actionLabelParams?: Record<string, string | number>;
  readonly actionValue?: string;
  readonly actionIcon?: IconName;
  readonly items: readonly MenuActionItem[];
}

export type MenuItem = MenuActionItem | MenuGroupItem | { readonly kind: 'separator' };

export type MenuRow =
  | { readonly id: string; readonly item: MenuActionItem; readonly kind: 'item' }
  | { readonly id: string; readonly kind: 'separator' }
  | {
      readonly id: string;
      readonly kind: 'title';
      readonly titleKey: string;
      readonly titleParams?: Record<string, string | number>;
      readonly actionLabelKey?: string;
      readonly actionLabelParams?: Record<string, string | number>;
      readonly actionValue?: string;
      readonly actionIcon?: IconName;
    };

export const MENU_SHEET_BREAKPOINTS = {
  closed: 0,
  initial: 0.4,
  expanded: 0.75,
} as const;

export const MENU_SHEET_BREAKPOINT_VALUES: readonly number[] =
  Object.values(MENU_SHEET_BREAKPOINTS);

export const VIEWPORT_BOTTOM_GAP_PX = 16;
